import { Box } from '@zillow/constellation-10';

export default function AvatarGroupWrapper({ children }: { children: React.ReactNode }) {
  return <Box css={{ display: 'flex', alignItems: 'center' }}>{children}</Box>;
}
